<template>
  <common-dialog
    v-loading="loadingData"
    ref="dialog"
    title="Edit Pick Up Info"
    :inputs-map="truckInfo"
    :input-value-change="valueChange"
    :save-cb="saveTruckInfo"
    :reset-inputs="resetTruckInfo"
  />
</template>
<script>
// others
import get from 'lodash/get'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// models
import { ShipmentPickUpInfoModifyForm } from '@/core/models/shipment'
// api
import { detailShipment, modifyShipmentPickUpInfo } from '@/api/shipment'
// msg
import PagesMessage from '@/core/message/pages'
export default {
  name: 'TruckEdit',
  components: {
    CommonDialog
  },
  data() {
    return {
      loadingData: false,
      truckInfo: [],
      truckInfoOriginal: {},
      shipmentId: ''
    }
  },
  methods: {
    async open(shipmentNo, cb) {
      const res = await detailShipment(shipmentNo)
      this.$set(this, 'shipmentId', res.id)
      this.$set(this, 'truckInfoOriginal', res.pickUpInfo ?? {})
      this.truckInfoOriginal.trailerNo = res.trailerNo
      this.truckInfoOriginal.sealNo = res.sealNo
      this.truckInfoOriginal.pickUpNo = res.pickUpNo
      this.resetTruckInfo()
      this.$refs.dialog.open()
    },
    resetTruckInfo() {
      const inputs = Object.keys(ShipmentPickUpInfoModifyForm).map(key => {
        return {
          ...ShipmentPickUpInfoModifyForm[key],
          value: get(this.truckInfoOriginal, key)
        }
      })
      this.$set(this, 'truckInfo', inputs)
    },
    valueChange() {},
    saveTruckInfo(info, done, error) {
      modifyShipmentPickUpInfo(this.shipmentId, info)
        .then(res => {
          done()
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_TRUCK)
        })
        .catch(err => {
          error(err.toString())
        })
    }
  }
}
</script>
